export default "__VITE_ASSET__c49067f1__"